import React from "react";
import LoginDialog from "./LoginDialog";
import NewPasswordRequiredDialog from "./NewPasswordRequiredDialog";
import RegisterDialog from "./RegisterDialog";
import ForgotPasswordDialog from "./ForgotPasswordDialog";
import MFARequiredDialog from "./MFARequiredDialog";

const AuthDialogs = () => (
    <>
        <LoginDialog />
        <NewPasswordRequiredDialog />
        <MFARequiredDialog />
        <RegisterDialog />
        <ForgotPasswordDialog />
    </>
);

export default AuthDialogs;
